(() => {
  'use strict';

  function makeLink(url, label, className) {
    const link = document.createElement('a');
    link.href = url;
    link.className = className;
    link.textContent = label;
    link.setAttribute('data-nawah-blog-link', 'true');
    return link;
  }

  function init() {
    const config = document.querySelector('[data-nawah-header-blog-config]');
    const header = document.querySelector('.nawah-header');
    if (!config || !header) return;

    const url = config.dataset.url || '/blogs/news';
    const label = config.dataset.label || 'Blog';

    const mobileStart = header.querySelector('.nawah-header__mobile-start');
    if (mobileStart && !mobileStart.querySelector('.nawah-header__blog-link--mobile')) {
      const link = makeLink(url, label, 'nawah-header__blog-link nawah-header__blog-link--mobile');
      link.setAttribute('aria-label', label);
      mobileStart.appendChild(link);
    }

    const desktopNav = header.querySelector('.nawah-header__nav--right');
    if (desktopNav && !desktopNav.querySelector('.nawah-header__blog-link--desktop')) {
      const link = makeLink(url, label, 'nawah-header__nav-link nawah-header__blog-link nawah-header__blog-link--desktop');
      desktopNav.prepend(link);
    }

    const mobileList = document.querySelector('.nawah-mobile-menu__nav > ul');
    if (mobileList && !mobileList.querySelector('[data-nawah-blog-menu-item]')) {
      const item = document.createElement('li');
      item.className = 'nawah-mobile-menu__item';
      item.setAttribute('data-nawah-blog-menu-item', 'true');
      const link = makeLink(url, label, 'nawah-mobile-menu__link');
      item.appendChild(link);
      mobileList.prepend(item);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
